import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

function useAutosaveInvoiceEmail(
  save: (email: string) => Promise<void>,
  defaultEmail?: string,
  debounceDelay = 300
) {
  const [inputValue, setInputValue] = useState<string>(defaultEmail || '');
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateEmail = (email: string): boolean => {
    return emailRegex.test(email);
  };

  const debouncedFunction = useDebouncedCallback(save, debounceDelay);

  useEffect(() => {
    if (validateEmail(inputValue)) {
      setIsEmailValid(true);
      if (inputValue !== defaultEmail) {
        debouncedFunction(inputValue);
      }
    } else if (inputValue) {
      setIsEmailValid(false);
    }
  }, [inputValue, debouncedFunction]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return { inputValue, isEmailValid, handleChange };
}

export { useAutosaveInvoiceEmail };
